export default "__VITE_ASSET__DPr_XEZt__"